module.exports = __webpack_public_path__ + "img/gao9.0b1db48d.png";